'use strict';

angular.module('msProfile', ['msUtility', 'msCore']).config(['$stateProvider', function ($stateProvider) {
  //this route provides youth co-branded profile UI
  $stateProvider.state('profile', {
    url: '/profile',
    templateUrl: 'profile/pages/main.html',
    resolve: {
      user: ['$state', 'userSvc', function ($state, userSvc) {
        return userSvc.getUser().then(function (user) {
          return user;
        }, function () {
          $state.go('error', {
            message: 'A networking error occurred'
          });
        });
      }],
      pane: function pane() {
        return 'profile';
      }
    },
    controllerAs: 'vm',
    controller: 'ProfilePageCtrl',
    data: {
      pageTitle: 'pageTitles.profile'
    }
  }).state('profile.settings', {
    url: '/settings',
    views: {
      detail: {
        template: '<profile user="$resolve.user" pane="$resolve.pane"/>'
      }
    },
    resolve: {
      pane: function pane() {
        return 'profile';
      }
    }
  });
}]).constant('context', 'profile');